import { linearGradient } from "polished"
import { ReactComponent as EditingImage } from "assets/image/editing__benefit_image2.svg"
import { ReactComponent as EmptyImage } from "assets/image/empty_insurance_image2.svg"
import { ReactComponent as ViewImage } from "assets/image/view_benefit_image2.svg"
import { ReactComponent as BenefitMainIcon } from "assets/icon/benefit_main_icon2.svg"
const colorConfigs = {
  "Green/Primary Text": "#313283",
  "Gray/Background ": "#E6E6E6",
  "Text/Dark": "#B39E9A",
  "Text/Primary Pink": "#E31C79",
  "Gray/Card Border, Line": "#A2AAAD",
  "Green/Primary Text2": "#009989",
  "Gray/Secondary Text": "#444444",
  "Gray/Line": "#828282",
  "Gray/Placeholder2": "#5D5D5D",
  "Red/Error Text": "#FF0000",
  "Warning Text": "#FAA61B",
  //
  "White / White": "#FFFFFF",
  "Green/Background": "#ECEDF8",
  "Error/Line": "#F6A660",
  "Error/Error Text": "#FF0000",
  "Text/Primary Text": "#000000",
  "Text/Secondary Text": "#333333",
  "Text/Line": "#7C7C7C",
  "Text/Placeholder": "#585858",
  "Text/Background": "#EAEAEA",
  "Gray/Primary Text": "#333333",
  "Text/Disable": "#C5C5C5",
  "Primary/Line": "#313283",
  "Primary/Hover": "#313283",
  "Primary/Primary Text": "#313283",
  "Primary/Background": "#ECEDF8",
  "Primary/Disable": "#ADADCD",
  Warning: "#FAA61B",
  Info: "#0084FF",
}

const backGroundColorGradient = linearGradient({
  colorStops: [`${colorConfigs["Primary/Primary Text"]} 81.24%`, `${colorConfigs["Info"]} 96.64%`],
  toDirection: "213deg",
  fallback: colorConfigs["Primary/Primary Text"],
})

const configs = {
  colors: colorConfigs,
  gradient: backGroundColorGradient,
  icons: {
    EditingImage: EditingImage,
    EmptyImage: EmptyImage,
    ViewImage: ViewImage,
    BenefitMainIcon: BenefitMainIcon,},
}

export default configs
